/*
 * interpolates between a set of colors uzing a bezier spline
 * blend mode formulas taken from https://web.archive.org/web/20180110014946/http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
 */

import '../io/rgb/index.js';
import chroma from '../chroma.js';
var _blend = function blend(bottom, top, mode) {
  if (!_blend[mode]) {
    throw new Error('unknown blend mode ' + mode);
  }
  return _blend[mode](bottom, top);
};
var blend_f = function blend_f(f) {
  return function (bottom, top) {
    var c0 = chroma(top).rgb();
    var c1 = chroma(bottom).rgb();
    return chroma.rgb(f(c0, c1));
  };
};
var each = function each(f) {
  return function (c0, c1) {
    var out = [];
    out[0] = f(c0[0], c1[0]);
    out[1] = f(c0[1], c1[1]);
    out[2] = f(c0[2], c1[2]);
    return out;
  };
};
var normal = function normal(a) {
  return a;
};
var multiply = function multiply(a, b) {
  return a * b / 255;
};
var darken = function darken(a, b) {
  return a > b ? b : a;
};
var lighten = function lighten(a, b) {
  return a > b ? a : b;
};
var screen = function screen(a, b) {
  return 255 * (1 - (1 - a / 255) * (1 - b / 255));
};
var overlay = function overlay(a, b) {
  return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
};
var burn = function burn(a, b) {
  return 255 * (1 - (1 - b / 255) / (a / 255));
};
var dodge = function dodge(a, b) {
  if (a === 255) return 255;
  a = 255 * (b / 255) / (1 - a / 255);
  return a > 255 ? 255 : a;
};

// # add = (a,b) ->
// #     if (a + b > 255) then 255 else a + b

_blend.normal = blend_f(each(normal));
_blend.multiply = blend_f(each(multiply));
_blend.screen = blend_f(each(screen));
_blend.overlay = blend_f(each(overlay));
_blend.darken = blend_f(each(darken));
_blend.lighten = blend_f(each(lighten));
_blend.dodge = blend_f(each(dodge));
_blend.burn = blend_f(each(burn));
// blend.add = blend_f(each(add));

export default _blend;